/**
 * The crew's people other than the one signed in (slice 6g §8): who a
 * public Area shows to, and who a private one doesn't.
 */
import { useMe } from "../../app/me";
import { usePeople } from "../people/api";

export function useOthers(): { id: string; name: string }[] {
  const me = useMe();
  const people = usePeople();
  const myId = me.data?.user.id;
  return (people.data?.people ?? []).filter((p) => p.id !== myId);
}
